import React from "react";
import { CustomColorBar } from "./ColorBarComponent";
import { COLORBAR_GRADIENT } from "./colorbarConstants";
import { useEnergyDataColorBar } from "../CustomHooks";

function extractTextInsideBrackets(str) {
  const matches = str?.match(/\[(.*?)\]/);
  const extractedText = matches ? matches[1] : null;
  if (extractedText === "h") {
    return "hours";
  }
  return extractedText;
}

const ColorBarEnergyData = () => {
  const { dataMax, dataMin, isVisible, subcategory } = useEnergyDataColorBar();

  return (
    <CustomColorBar
      gradient={COLORBAR_GRADIENT.ENERGY}
      category="Energy Data"
      subcategory={subcategory}
      unit={extractTextInsideBrackets(subcategory)}
      dataMin={dataMin}
      dataMax={dataMax}
      isVisible={isVisible}
    />
  );
};

export default ColorBarEnergyData;
